const validateAccess = {
  title: 'Generar contraseña de acceso para validación',
  description:
    'Al enviar el documento digital para generar una contraseña de acceso para terceros, confirmo que tengo conocimiento de que este documento estará disponible durante 12 meses, protegido bajo medidas de seguridad mediante contraseña.',
  help: 'Para eliminar la disponibilidad, póngase en ',
  contact: 'contacta',
  contactLink: 'https://www.clicksign.com/suporte',
};

export default validateAccess;
